import React from 'react';

import Navbar from 'react-bootstrap/Navbar';

import '../styles.css';

export const NavBar = () => {

    return (
        <div>
            <Navbar className="navbar">
                <Navbar.Brand>
                    <h1>COVID-19</h1>
                </Navbar.Brand>
            </Navbar>
        </div>
    )

}
